<template>
    <modal name="createDokumen" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("dokumen_lampiran") }} </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>


                    <form class="forms-sample" @submit.prevent="submitDataDokumen" method="POST"
                        enctype="multipart/form-data">

                        <div class="modal-body">


                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('seri') }} </label>
                                <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('seri')"
                                    v-model="form_dokumen.seriDokumen" disabled />
                                <div v-if="errors.seriDokumen">
                                    <div v-for="error in errors.seriDokumen" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('jenis_dokumen') }} </label>

                                <v-select :options="fetchKodeDokumen" v-model="kode_dokumen" label="label" return-object
                                    @input="(country) => updateKodeDokumen(country)">
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="errors.kodeDokumen">
                                    <div v-for="error in errors.kodeDokumen" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('nomor_dokumen') }} </label>
                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    :placeholder="$t('nomor_dokumen')" v-model="form_dokumen.nomorDokumen" required
                                    maxlength="255" />
                                <div v-if="errors.nomorDokumen">
                                    <div v-for="error in errors.nomorDokumen" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('tanggalDokumen') }} </label>

                                <br>

                                <date-picker v-model="form_dokumen.tanggalDokumen" input-class="form-control"
                                    placeholder="YYYY-MM-DD" format="YYYY-MM-DD" valueType="format" type="date"
                                    required></date-picker>

                                <div v-if="errors.tanggalDokumen">
                                    <div v-for="error in errors.tanggalDokumen" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('fasilitas_dokumen') }} </label>

                                <v-select :options="fetchFasilitasDokumen" v-model="fasilitas_dokumen" label="label"
                                    return-object @input="(country) => updateFasilitasDokumen(country)">
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="errors.kodeFasilitas">
                                    <div v-for="error in errors.kodeFasilitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('izin') }} </label>

                                <v-select :options="fetchIjin" v-model="ijinDokumen" label="label"
                                    return-object></v-select>

                                <div v-if="errors.kodeIjin">
                                    <div v-for="error in errors.kodeIjin" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('file') }} </label>

                                <input type="file" ref="fileDokumen" class="form-control"
                                    @change="handleFileUpload($event)" />

                                <div v-if="errors.urlDokumen">
                                    <div v-for="error in errors.urlDokumen" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>



                        </div>


                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                                this.$t("close_txt") }}</button>
                            <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/id';
export default {
    name: "modalDocumentAdd",
    components: {
        DatePicker
    },
    props: {
        docId: Number,
        seriNo: Number
    },
    data() {
        return {
            errors: [],
            form_dokumen: { document_dokumen_id: "", document_id: "", idDokumen: "", kodeDokumen: "", namaDokumen: "", kodeFasilitas: "", namaFasilitas: "", kodeIjin: "", namaIjin: "", nomorDokumen: "", kodeKantor: "", namaKantor: "", tanggalDokumen: "", seriDokumen: "", urlDokumen: "" },

            fetchKodeDokumen: [],
            kode_dokumen: { code: "", name: "", label: "" },
            fetchFasilitasDokumen: [],
            fasilitas_dokumen: { code: "", name: "", label: "" },

            fetchIjin:[],
            ijinDokumen:null,
        }
    },
    methods: {
        submitDataDokumen() {

            this.isLoading = true;

            let formData = new FormData();
            formData.append("document_id", this.docId);
            formData.append("idDokumen", this.form_dokumen.idDokumen);
            formData.append("kodeDokumen", this.form_dokumen.kodeDokumen);
            formData.append("namaDokumen", this.form_dokumen.namaDokumen);
            formData.append("kodeFasilitas", this.form_dokumen.kodeFasilitas);
            formData.append("namaFasilitas", this.form_dokumen.namaFasilitas);
            formData.append("kodeIjin", this.ijinDokumen?.code ? this.ijinDokumen.code : "");
            formData.append("namaIjin", this.ijinDokumen?.name ? this.ijinDokumen.name : "");
            formData.append("nomorDokumen", this.form_dokumen.nomorDokumen);
            formData.append("kodeKantor", this.form_dokumen.kodeKantor);
            formData.append("namaKantor", this.form_dokumen.namaKantor);
            formData.append("tanggalDokumen", this.form_dokumen.tanggalDokumen);
            formData.append("seriDokumen", this.form_dokumen.seriDokumen);
            formData.append("urlDokumen", this.fileDokumen);

            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-4";
            this.$http.post(baseURI, formData, { timeout: 100000 }).then((response) => {
                if (response.data.status === 200) {
                    this.isLoading = false;
                    this.errors = [];
                    this.removeModals();
                    this.$emit("setValue");
                    this.fasilitas_dokumen = { code: "", name: "", label: "" };
                    this.kode_dokumen = { code: "", name: "", label: "" };
                    this.ijinDokumen = { code: "", name: "", label: "" };
                    this.form_dokumen = { document_dokumen_id: "", document_id: "", idDokumen: "", kodeDokumen: "", namaDokumen: "", kodeFasilitas: "", namaFasilitas: "", kodeIjin: "", namaIjin: "", nomorDokumen: "", kodeKantor: "", namaKantor: "", tanggalDokumen: "", seriDokumen: "", urlDokumen: "" };
                    this.fileDokumen = "";
                } else {
                    this.isLoading = false;
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
            });

        },

        asyncFasilitasDokumen() {

            this.fetchFasilitasDokumen = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=kodeFasilitas";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchFasilitasDokumen.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncIjinDokumen() {

            this.fetchIjin = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&page=1&type=kodeIjin";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchIjin.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },

        asyncKodeDokumen() {

            this.fetchKodeDokumen = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=200&page=1&type=kodeDokumen";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchKodeDokumen.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },

        removeModals() {
            this.$modal.hide('createDokumen');
        },
        updateFasilitasDokumen(data) {

            if (data) {

                this.form_dokumen.kodeFasilitas = data.code
                this.form_dokumen.namaFasilitas = data.name

            } else {

                this.form_dokumen.kodeFasilitas = ""
                this.form_dokumen.namaFasilitas = ""

            }

        },
        updateKodeDokumen(data) {

            this.form_dokumen.kodeDokumen = data.code
            this.form_dokumen.namaDokumen = data.name

        },
        handleFileUpload(event) {
            this.fileDokumen = event.target.files[0];
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
    },
    watch: {
        seriNo: function (newVal) {
            this.form_dokumen.seriDokumen = newVal;

        },
    },
    created() {
        this.asyncKodeDokumen();
        this.asyncFasilitasDokumen();
        this.asyncIjinDokumen();
    },
}
</script>

<style></style>